const numberToLetter = (datum) => {
  let number = datum.data.value
  let result = []
  let letters = 26

  let times = number / letters
  if (times > 1) {
    result.push(String.fromCharCode(64 + times))
  }

  number = number % letters

  result.push(String.fromCharCode(65 + number))
  datum.data.text = result.join('')
  return datum
}

export default {
  unparseData: function() {
    let spreadsheets = Object.values(this.parsedData)
    let results = []
    for (let i = 0; i < spreadsheets.length; i++) {
      let spreadsheet = spreadsheets[i]
      let maxWidth = this.maxWidth[i]
      let data = spreadsheet.data.filter(datum => !datum.data.isDeleted).map(datum => ({
        value: datum.data.value,
      }))

      let rows = []
      if (maxWidth != 0) {
        for (let j = 0; j < data.length; j += maxWidth) {
          rows.push(data.slice(j, j + maxWidth))
        }
      }

      results.push({
        data: rows,
        name: spreadsheet.name,
      })
    }

    return {
      sheets: results,
      changes: this.undoHistory.map(change => ({
        location: change.location,
        changeType: change.changeType,
      })),
    }
  },
  parseData: function(spreadsheets, getLogs) {
    if (!spreadsheets || spreadsheets.length == 0) return

    this.initializeMaxWidth(spreadsheets)

    this.rowHeaders = []
    this.columnHeaders = []

    for (let i = 0; i < spreadsheets.length; i++) {
      let spreadsheet = spreadsheets[i]
      let rowCount = spreadsheet.data.length
      let columnCount = this.maxWidth[i]

      for (let j = 0; j < rowCount; j++) {
        let row = spreadsheet.data[j]

        while (row.length < columnCount) {
          row.push({ value: '' })
        }

        for (let k = 0; k < row.length; k++) {
          let cell = row[k]
          cell.location = this.getIndex(i, j, k)

          cell.initialValue = cell.value
          cell.isDeleted = false

          if (getLogs(cell.location)) {
            cell.logLocation = cell.location
          }
        }
      }

      let rowHeaders = this.makeHeader(rowCount)
      this.rowHeaders.push(rowHeaders)

      let columnHeaders = this.makeHeader(columnCount).map(numberToLetter)
      this.columnHeaders.push(columnHeaders)
    }

    this.spreadsheetHeaders = spreadsheets.map(spreadsheet => ({ name: spreadsheet.name }))
    this.initializeDataLengths(spreadsheets)

    spreadsheets.forEach(spreadsheet => {
      spreadsheet.data = spreadsheet.data.flatten().map(datum => { return { data: datum } })
    })

    this.parsedData = spreadsheets
  },
}